/* ============
 * Contract Module
 * ============
 */

import actions from "./actions";

export default {
  state: {
  },
  actions,
};
